import { Directive } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';

import { MenuItem } from 'primeng/api';

import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { createActiveRoute$, createChildRouteSnapshot$ } from 'sc-common/core/utils/active-route';

@Directive()
export abstract class DetailsLayoutBaseComponent {

    public readonly activeItem$: Observable<MenuItem>;
    public readonly activeRoute$: Observable<string>;

    // For future purpose in order to highlight selected menu items
    private readonly _routeActiveItems$: Observable<MenuItem[]>;

    constructor(
        protected readonly _route: ActivatedRoute,
        protected readonly _router: Router,
        public navigationTabs: MenuItem[],
        private readonly _exactRouteCheck: boolean = false) {

        const childRouteItem$ = createChildRouteSnapshot$(_router);

        this._routeActiveItems$ = childRouteItem$.pipe(filter(x => !!x), map(x => this._getActiveMenuItems(x)));

        this.activeItem$ = this._routeActiveItems$.pipe(map(x => x?.length ? x[x.length - 1] : null));

        this.activeRoute$ = createActiveRoute$(_router, _route);
    }

    private _getActiveMenuItems(routeSnapshot: ActivatedRouteSnapshot): MenuItem[] {

        const indexOfCurrentRoute = routeSnapshot.pathFromRoot.findIndex(x => x.routeConfig === this._route.snapshot.routeConfig);

        // Get path segments list starting from current component route.
        // Ignore empty paths.
        const pathList = routeSnapshot.pathFromRoot
            .filter((x, i) => i > indexOfCurrentRoute && x.routeConfig.path)
            .reduce<string[]>((p, n) => [...p, ...n.url.map(u => u.path)], []);

        // Calculate the active item according to path which starts from current route and ends with most nested route.
        return this._findActiveMenuItems(this.navigationTabs, pathList);
    }

    private _findActiveMenuItems(menuItems: MenuItem[], pathList: string[]): MenuItem[] {

        for (const menuItem of menuItems) {

            const found = Array.isArray(menuItem.routerLink)
                ? (!this._exactRouteCheck || menuItem.routerLink.length === pathList.length)
                && menuItem.routerLink.every((r: any, rIndex: number) => pathList.some((p, pIndex) => r === p && rIndex === pIndex))
                : menuItem.routerLink === pathList[0];

            if (found) {

                return [menuItem];

            } else if (menuItem.items?.length) {

                const foundItem = this._findActiveMenuItems(menuItem.items, pathList);

                if (foundItem?.length) {

                    return [menuItem, ...foundItem];
                }
            }
        }

        return [];
    }
}
